<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container">
      <span class="navbar-brand">Kulineran App</span>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/foods">Foods</router-link>
          </li>
        </ul>
      </div>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/pesanan">
              <b-icon icon="handbag"></b-icon>
              Pesanan
              <span class="badge badge-success ml-1">{{ pesanan.length }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import { API_URL } from "../utils/constant";

export default {
  name: "Navbar",
  data() {
    return {
      pesanan: "",
    };
  },
  methods: {
    setKeranjang(data) {
      this.pesanan = data;
    },
  },
  mounted() {
    axios
      .get(API_URL + "/pesanan")
      .then((res) => {
        this.setKeranjang(res.data);
      })
      .catch((err) => {
        console.log(`err`, err);
      });
  },
};
</script>

<style scope>
.router-link-exact-active {
  font-weight: bold;
  color: #00b95d !important;
}
</style>
